var ParalaxRun=0;
var paralaxParams={};


if($(window).width()>767){
	if(window.location.hash!='#adv'){
		var ParalaxRun=1;
	}
}


function ParalaxSetParams(){
	if($('#index-blocs').length && ParalaxRun){

		paralaxParams.items=$('#content').children('.row').children();

		paralaxParams.windowHeight=$(window).height();
		paralaxParams.windowWidth=$(window).width();
		paralaxParams.fixedMenuHeight=$('.top-fixed').height();

		paralaxParams.topPos=$(paralaxParams.items[0]).offset().top+parseInt($(paralaxParams.items[0]).css('padding-top')) - paralaxParams.fixedMenuHeight;
		//console.log('set pos '+paralaxParams.topPos);

		//$('title').html(paralaxParams.topPos)
		paralaxParams.heights=[]
		$(paralaxParams.items).each(function(pCounter,item){
			paralaxParams.heights[pCounter]=$(item).children('.paral-wrapper').height();
			//console.log(pCounter)
		})


		if(paralaxParams.heights[0] > paralaxParams.heights[1]){
			paralaxParams.parallIdx=1;
			paralaxParams.MaxIdx=0
		}else{
			paralaxParams.parallIdx=0;
			paralaxParams.MaxIdx=1;
		}

		paralaxParams.max=paralaxParams.items[paralaxParams.MaxIdx];
		paralaxParams.maxHeight=paralaxParams.heights[paralaxParams.MaxIdx]
		paralaxParams.parallItem=paralaxParams.items[paralaxParams.parallIdx]

		paralaxParams.parallWrapItem=$(paralaxParams.items[paralaxParams.parallIdx]).find('.paral-wrapper');
		$(paralaxParams.parallWrapItem).css({'position':'fixed','width':$(paralaxParams.parallWrapItem).width()+'px'})

		paralaxParams.MaxHidden=paralaxParams.heights[paralaxParams.MaxIdx]-paralaxParams.windowHeight+paralaxParams.fixedMenuHeight;
		paralaxParams.ParalMaxHidden=paralaxParams.heights[paralaxParams.parallIdx]-paralaxParams.windowHeight+paralaxParams.fixedMenuHeight;


		paralaxParams.parallaxType= paralaxParams.heights[paralaxParams.parallIdx] > paralaxParams.windowHeight-paralaxParams.fixedMenuHeight  ? 'parallax' : 'fixToTop';
		paralaxParams.heightsDiff = paralaxParams.heights[paralaxParams.MaxIdx]-paralaxParams.heights[paralaxParams.parallIdx];

		//если прокрутили уже до фиксированного элемента или ниже его
		//parallax - если высота позиционируемого элемента больше зоны видимости (высота окна без фиксированного меню)
		//fixToTop - то фисируем его в верхней точке зоны видимости


		$(paralaxParams.parallItem).css({'position':'relative'})
		//$('title').html(paralaxParams.heights[1])
		//console.log('update paralax: '+paralaxParams.heights[1])
		//console.log(paralaxParams);
		ParalaxChange()
	}
}

function ParalaxChange(){

	if( (paralaxParams.windowWidth>767) && ParalaxRun) {

			var scrollTop=$(window).scrollTop();
			var cssTop=0;

				//console.log(scrollTop,paralaxParams.topPos);
				if(scrollTop < paralaxParams.topPos){
					//пока не докрутили до границы фиксированного элемента, все должно быть на своих местах
					cssTop=paralaxParams.topPos-scrollTop;
					if( $(paralaxParams.parallWrapItem).css('position') !='static'){
						$(paralaxParams.parallWrapItem).css({'position':'static'})
					}
				}else{
					//console.log(paralaxParams.parallaxType);
					//если докрутили уже до верхней границы фиксированного элемента
				//	console.log(paralaxParams.maxHeight + paralaxParams.topPos -paralaxParams.windowHeight);
					if(scrollTop > ( paralaxParams.maxHeight + paralaxParams.topPos -paralaxParams.windowHeight )  ){
					//если уже ниже нижней границы фиксированного элемента
						//alert('bottom');
						if(paralaxParams.parallaxType=='parallax'){
							cssTop=paralaxParams.topPos+(paralaxParams.MaxHidden-paralaxParams.ParalMaxHidden)-scrollTop;
						}else{
							if(paralaxParams.parallaxType=='fixToTop'){
								if(scrollTop > paralaxParams.topPos + paralaxParams.heightsDiff){
									//если позиционируемый элемент дошел до нижней границы фиксированного, то он уже не фиксируется вверху страницы, а продолжает плыть вверх с ней
									cssTop=paralaxParams.fixedMenuHeight-(scrollTop -( paralaxParams.topPos + paralaxParams.heightsDiff))
								}else{
									cssTop=paralaxParams.fixedMenuHeight
								}
							}
						}
					}else{
						//	console.log(paralaxParams.parallaxType);
							// в этот момент применяем параллакс (в этот момент фиксированный элемент занимает все высоту экрана и часть его скрыта либо выше либо ниже)
							if(paralaxParams.parallaxType=='parallax'){
								var VisPercent=(scrollTop-paralaxParams.topPos)/paralaxParams.MaxHidden;
								cssTop=-VisPercent*paralaxParams.ParalMaxHidden+paralaxParams.fixedMenuHeight;
							}else{
								if(paralaxParams.parallaxType=='fixToTop'){
									cssTop=paralaxParams.fixedMenuHeight;
								}
							}


					}

					if( $(paralaxParams.parallWrapItem).css('position') !='fixed'){
						$(paralaxParams.parallWrapItem).css({'position':'fixed'}) ;
					}
					$(paralaxParams.parallWrapItem).css({'top':cssTop}) ;



				}

	}
}


$(window).scroll(function(){
	ParalaxChange();
})
$(document).ready(function(){
	ParalaxSetParams();
})
